import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';

const DocumentManual = ({ match }) => {
    const requestedUrl = match.url.replace(/\/$/, '');
    return (
        <Suspense fallback={<PageLoader />}>
            <Switch>
                <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/manual`} />
                <Route path={`${requestedUrl}/manual`} component={lazy(() => import('./manual'))} />
                <Route path={`${requestedUrl}/note-version`} component={lazy(() => import('./noteVersion'))} />
            </Switch>
        </Suspense>
    );
};

export default DocumentManual;
